function setTimePeriod() {
  let end;
  const clientWidth = this.screenWidth;
  if (clientWidth >= 1300) {
    end = 7;
  } else if (clientWidth >= 1000) {
    end = 6;
  } else if (clientWidth >= 1024) {
    end = 5;
  } else {
    end = 4;
  }
  const start = this.riskData.length - end;
  this.state.timeBlock = {
    start,
    end,
    maxStart: start,
  };
}


export default setTimePeriod;



// WEBPACK FOOTER //
// ./src/helpers/windowResize.js